import { useState } from 'react';
import './App.css';
import { trackGaEvent } from './analytics';

const TEAM = [
  {
    initials: 'SB',
    name: 'Seymour Bush',
    role: 'CEO & Lead Pube Contributor',
    bio: 'Current CEO due to largest volume of contributions.Says “synergy” less than you’d expect.',
    gradient: 'linear-gradient(135deg, #6366f1, #4338ca)',
  },
  {
    initials: 'AB',
    name: 'Anita Bush',
    role: "Seymour's Mom, Head of Sewing",
    bio: 'Can eyeball a stitch count from across the room. Proud of her son.',
    gradient: 'linear-gradient(135deg, #0891b2, #6366f1)',
  },
  {
    initials: 'NB',
    name: 'Grandma',
    role: "Anita's Mom, Senior Sew Team Member, Unpaid Intern",
    bio: 'The heart and soul of the operation. Has clocked a whopping 43,000 uncleaned pubes sewn in her 32 years of industry experience.',
    gradient: 'linear-gradient(135deg, #7c3aed, #db2777)',
  },
];

const SOCK_PALETTE = [
  {
    name: 'Drainline Slate',
    desc: 'Reads & smells “professional.”',
    image: 'palette-drainline-slate.png',
  },
  {
    name: 'Compost Pine',
    desc: 'For nature lovers. Sourced mostly from passed-out drunks on St. Patty\'s Day.',
    image: 'palette-compost-pine.png',
  },
  {
    name: 'Landfill Ember',
    desc: 'We call this the "conversation starter"',
    image: 'palette-landfill-ember.png',
  },
  {
    name: 'Glacier Lint',
    desc: 'Sometimes we throw a Nike symbol on these just to shake things up.',
    image: 'palette-glacier-lint.png',
  },
  {
    name: 'Omni-Mottle™',
    desc: 'A crowd-sourced oatmeal situation. You know exactly what I\'m talkin about',
    image: 'palette-omni-mottle.png',
  },
  {
    name: 'Sunset Patchwork',
    desc: 'This one actually turned out quite alright!.',
    image: 'palette-sunset-patchwork.png',
  },
];

const waitlistEndpoint =
  process.env.REACT_APP_WAITLIST_URL?.trim() || '/.netlify/functions/waitlist';

function App() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notifyError, setNotifyError] = useState(null);

  async function handleNotify(e) {
    e.preventDefault();
    if (!email.trim()) return;
    setNotifyError(null);
    setLoading(true);
    try {
      const res = await fetch(waitlistEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });
      let data = {};
      try {
        data = await res.json();
      } catch {
        /* non-JSON response */
      }
      if (!res.ok) {
        throw new Error(data.error || `Something broke (${res.status})`);
      }
      setSubmitted(true);
      setEmail('');
      trackGaEvent('generate_lead', { method: 'waitlist' });
    } catch (err) {
      setNotifyError(err.message || 'Network hiccup—try again.');
    } finally {
      setLoading(false);
    }
  }

  function scrollTo(id) {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  }

  function handlePartnerClick() {
    trackGaEvent('select_promotion', {
      promotion_name: 'coccams_razor',
      creative_name: 'announcement_bar',
    });
  }

  return (
    <div className="landing">
      <header className="site-header">
        <div className="nav">
          <div className="nav-inner">
            <span className="nav-brand">Pube Socks</span>
            <nav className="nav-links" aria-label="Primary">
              <a href="#mission" onClick={(e) => { e.preventDefault(); scrollTo('mission'); }}>Mission</a>
              <a href="#timeline" onClick={(e) => { e.preventDefault(); scrollTo('timeline'); }}>Timeline</a>
              <a href="#about-product" onClick={(e) => { e.preventDefault(); scrollTo('about-product'); }}>Product</a>
              <a href="#future-products" onClick={(e) => { e.preventDefault(); scrollTo('future-products'); }}>Future</a>
              <a href="#team" onClick={(e) => { e.preventDefault(); scrollTo('team'); }}>Team</a>
            </nav>
            <button type="button" className="nav-cta" onClick={() => scrollTo('notify')}>
              Get on the list
            </button>
          </div>
        </div>
        <div className="announcement" role="region" aria-label="Partner announcement">
          <p className="announcement-inner">
            <span className="announcement-label">Now live</span>
            Our partner project{' '}
            <strong>Coccam&apos;s Razor</strong> — one blade, tidier donations, same deranged ecosystem.{' '}
            <a
              href="https://coccamsrazor.xyz"
              target="_blank"
              rel="noopener noreferrer"
              className="announcement-link"
              onClick={handlePartnerClick}
            >
              Check it out →
            </a>
          </p>
        </div>
      </header>

      <section className="hero" aria-labelledby="hero-heading">
        <div>
          <p className="hero-badge">
            <span className="hero-badge-dot" aria-hidden />
            Yes, we’re serious · no, your roommate isn’t ready
          </p>
          <h1 id="hero-heading">
            Your Pubes, Our Socks
          </h1>
          <p className="hero-lede">
            Stop treating the sink like a magic disappearing act. Mail us the goods, we knit something vaguely sock-shaped,
            and—plot twist—you pay slightly less if you’ve donated enough fuzz to matter. Chores-first capitalism..
          </p>
          <div className="hero-actions">
            <button type="button" className="btn-primary" onClick={() => scrollTo('notify')}>
              I'm already sold, notify me
            </button>
            <button type="button" className="btn-ghost" onClick={() => scrollTo('timeline')}>
              How this circus works
            </button>
          </div>
        </div>
        <div className="hero-visual" aria-label="Product visualization">
          <span className="hero-visual-glow" aria-hidden />
          <img
            src={`${process.env.PUBLIC_URL}/product-hero.png`}
            alt="One disturbingly scraggly sock, stained and frayed, photographed like a luxury drop"
            width={960}
            height={720}
          />
        </div>
      </section>

      <section id="mission" className="section mission" aria-labelledby="mission-heading">
        <div className="mission-inner">
          <div>
            <p className="section-label">Mission</p>
            <h2 id="mission-heading">Save the planet.</h2>
          </div>
          <div>
            <blockquote className="mission-quote">
              Every flush is basically a tiny environmental temper tantrum. We’re asking you to pause, scrape it into a bag
              like an adult, and let us spin it into socks your enemies will smell from across the room. Same footprint,
              louder outcome — minus whatever chaos that blob would’ve caused downstream.
            </blockquote>
            <div className="mission-stats">
              <div className="stat">
                <div className="stat-value">≈0</div>
                <div className="stat-label">Pubes we want in your pipes</div>
              </div>
              <div className="stat">
                <div className="stat-value">2 or 3</div>
                <div className="stat-label">Mailers we swear are “fine”</div>
              </div>
              <div className="stat">
                <div className="stat-value">Too many</div>
                <div className="stat-label">Meetings about custody paperwork</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="timeline" className="section" aria-labelledby="timeline-heading">
        <p className="section-label">Production timeline</p>
        <h2 id="timeline-heading" className="section-heading-wide">
          Bathroom jar → glorified yarn → mild discount coupons.
        </h2>
        <p className="section-lede">
          Four steps. Zero poetry. If your contributor credits vanish, check Seymour’s clipboard—it’s never “the cloud.”
        </p>
        <div className="timeline-grid">
          <article className="timeline-card">
            <p className="timeline-phase">Step 1</p>
            <h3>You send pubes</h3>
            <ul>
              <li>We mail you a bag that looks suspiciously legitimate</li>
              <li>You lie about the weight on the form (we weigh it anyway)</li>
              <li>No liquids. We’re gross, not sloppy</li>
            </ul>
            <span className="timeline-status live">Still accepting chaos</span>
          </article>
          <article className="timeline-card">
            <p className="timeline-phase">Step 2</p>
            <h3>Construction Team intake</h3>
            <ul>
              <li>Someone squints at it under bad lighting</li>
              <li>Sorted like Pokémon cards but somehow worse</li>
              <li>Credits hit your wallet before Grandma finishes asking what you do for work</li>
            </ul>
            <span className="timeline-status live">Anita’s judging your knot</span>
          </article>
          <article className="timeline-card">
            <p className="timeline-phase">Step 3</p>
            <h3>Knit &amp; finish</h3>
            <ul>
              <li>Ratios are “proprietary” (read: eyeballed)</li>
              <li>Heel reinforcement because shame shouldn’t mean holes</li>
              <li>Embroidery options exist if your employer hates you</li>
            </ul>
            <span className="timeline-status planned">Machines sound haunted</span>
          </article>
          <article className="timeline-card">
            <p className="timeline-phase">Step 4</p>
            <h3>Order &amp; discounted checkout</h3>
            <ul>
              <li>Sticker price first—then we knock it down out of guilt/gratitude</li>
              <li>More verified fuzz on file = fewer dollars leaving your pocket</li>
              <li>Subscriptions stack until Legal sends a mean email</li>
            </ul>
            <span className="timeline-status planned">Discount math is vibes-based</span>
          </article>
        </div>
      </section>

      <section id="about-product" className="section about-product" aria-labelledby="about-heading">
        <p className="section-label">About the product</p>
        <h2 id="about-heading" className="section-heading-wide">
          Short socks vs long socks: the pube accounting you've been waiting for.
        </h2>
        <p className="section-lede">
          Tall cuffs eat more fiber. That’s it. That’s the science. We publish numbers so support tickets sound smarter.
        </p>

        <div className="spec-table-wrap">
          <table className="spec-table">
            <caption className="visually-hidden">Pube requirements by sock length</caption>
            <thead>
              <tr>
                <th scope="col">Silhouette</th>
                <th scope="col">Approx. pubes</th>
                <th scope="col">Reality check</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Short socks <span className="spec-muted">(no-show / ankle / quarter crew)</span></td>
                <td><strong>14,000 – 20,000</strong></td>
                <td>Starter tier. Perfect if you’re curious, but not sold.</td>
              </tr>
              <tr>
                <td>Long socks <span className="spec-muted">(crew+ / over-calf / compression)</span></td>
                <td><strong>32,000 – 48,000</strong></td>
                <td>Ask for "shin guards" at checkout. We'll consider it.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="subsection-title">Palette &amp; multi-donor finishes</h3>
        <p className="subsection-lede">
          Single-color socks for cowards with boundaries. Multi-donor blends for those who live on the edge.
        </p>
        <div className="palette-grid">
          {SOCK_PALETTE.map((sock) => (
            <article key={sock.name} className="palette-card">
              <div className="palette-photo">
                <img
                  src={`${process.env.PUBLIC_URL}/palette/${sock.image}`}
                  alt={`${sock.name}: realistic product shot of a deliberately ugly sock finish`}
                  width={640}
                  height={384}
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <h4>{sock.name}</h4>
              <p>{sock.desc}</p>
            </article>
          ))}
        </div>
      </section>

      <section id="future-products" className="section future-products" aria-labelledby="future-heading">
        <p className="section-label">Pipeline</p>
        <h2 id="future-heading" className="section-heading-wide">
          The obvious future products
        </h2>
        <div className="future-grid">
          <article className="future-card future-card-featured">
            <p className="future-badge">Horrible synergy</p>
            <h3>Full-Circle Condoms™</h3>
            <p>
              Leftovers gotta go somewhere. If elastomer’s lying around acting cocky, we roll it into something billed as “natural”
              with packaging that uses the word “honest” too many times. Socks walked so condoms could sprint—toward FDA paperwork,
              hopefully.
            </p>
          </article>
          <article className="future-card">
            <h3>Elastic recovery bands</h3>
            <p>
              Gym-core accessory built from sock scraps that didn’t make the cut. Bro science meets recycling guilt.
            </p>
          </article>
          <article className="future-card">
            <h3>Civic compost mesh</h3>
            <p>
              The government-core line: low-grade fiber bundled into “erosion control.” Sounds heroic; mostly mulch cosplay.
            </p>
          </article>
        </div>
      </section>

      <section id="notify" className="section" aria-labelledby="notify-heading">
        <div className="notify">
          <p className="section-label">Waitlist</p>
          <h2 id="notify-heading">Get notified</h2>
          <p>
            Drop your email if you want updates, drama, and deeply unnecessary spreadsheets. We promise almost nothing.
          </p>
          <form className="notify-form" onSubmit={handleNotify}>
            <label htmlFor="notify-email" className="visually-hidden">
              Email address
            </label>
            <input
              id="notify-email"
              type="email"
              name="email"
              autoComplete="email"
              placeholder="you@totally-normal-job.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Sending…' : 'Do it'}
            </button>
          </form>
          {notifyError ? (
            <p className="notify-error" role="alert">
              {notifyError}
            </p>
          ) : null}
          {submitted ? (
            <p className="notify-success" role="status">
              Cool. You’re in. Don’t blame us when marketing gets weird.
            </p>
          ) : null}
        </div>
      </section>

      <section id="team" className="section" aria-labelledby="team-heading">
        <p className="section-label">People</p>
        <h2 id="team-heading">Meet the team</h2>
        <div className="team-grid">
          {TEAM.map((member) => (
            <article key={member.name} className="team-card">
              <div className="team-avatar" style={{ background: member.gradient }}>
                {member.initials}
              </div>
              <h3>{member.name}</h3>
              <p className="team-role">{member.role}</p>
              <p className="team-bio">{member.bio}</p>
            </article>
          ))}
        </div>
      </section>

      <footer className="footer">
        <p>
          © {new Date().getFullYear()} Pube Socks Inc. Not medical advice. Not fashion advice. Barely advice.
        </p>
      </footer>
    </div>
  );
}

export default App;
